import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DateTimeFormatPipe } from './shared/pipes/date-time-format.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { HeaderComponent } from './components/template/header/header.component';
import { FooterComponent } from './components/template/footer/footer.component';
import { AcompanhamentoComponent } from './pages/acompanhamento/acompanhamento.component';
import { HomeComponent } from './pages/home/home.component';

import { TamanhoFonteComponent } from './components/template/tamanho-fonte/tamanho-fonte.component';
import { OnlyNumbersDirective } from './shared/directive/only-numbers/only-numbers.directive';
import { CpfPipe } from './shared/pipes/cpf.pipe';
import { PhonePipe } from './shared/pipes/phone.pipe';
import { FichainscricaoComponent } from './pages/fichainscricao/fichainscricao.component';
import { ConfirmacaoinscricaoComponent } from './pages/confirmacaoinscricao/confirmacaoinscricao.component';
import { DocumentosComponent } from './pages/documentos/documentos.component';
import { InputrestrictionDirective } from './shared/directive/inputrestriction/inputrestriction.directive';
import { MaskDirective } from './shared/directive/mask/mask.directive';
import { ValidatedateDirective } from './shared/directive/Validatedate/validatedate.directive';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { NgSelectModule } from '@ng-select/ng-select';
import { NumeroInscricaoPipe } from './shared/pipes/numero-inscricao.pipe';

import { FileSaverModule } from 'ngx-filesaver';
import { DateFormatPipe } from './shared/pipes/date-format.pipe';
import { CepFormatPipe } from './shared/pipes/cep-format.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';

const maskConfig: Partial<IConfig> = {
    validation: false,
    showMaskTyped: false,
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AcompanhamentoComponent,
    TamanhoFonteComponent,
    OnlyNumbersDirective,
    CpfPipe,
    PhonePipe,
    FichainscricaoComponent,
    ConfirmacaoinscricaoComponent,
    DocumentosComponent,
    InputrestrictionDirective,
    MaskDirective,
    ValidatedateDirective,
    NumeroInscricaoPipe,
    DateTimeFormatPipe,
    DateFormatPipe,
    CepFormatPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgSelectModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    FileSaverModule,
    TooltipModule.forRoot(),
    NgxMaskModule.forRoot(maskConfig),
    ToastrModule.forRoot({
      timeOut: 5000,
      progressBar: true,
      progressAnimation: 'increasing',
      preventDuplicates: true,
      positionClass: 'toast-center-center'
    }),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })
  ],
  exports: [
    OnlyNumbersDirective
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
